import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import EditLineIcon from 'remixicon-react/EditLineIcon';
import LinkUnlinkIcon from 'remixicon-react/LinkUnlinkIcon';
import { useI18n } from '../../i18n';
import { MenuItem } from './BubbleMenuItem';
import { LinkFormDialog } from './LinkFormDialog';
export const LinkFormattingMenu = ({ editor }) => {
    var _a;
    const intl = useI18n();
    const [linkFormState, setLinkFormState] = useState({
        open: false,
        text: '',
        href: undefined,
    });
    const { view, state } = editor;
    const { from, to } = view.state.selection;
    const text = state.doc.textBetween(from, to, '');
    const { marks } = state.doc.nodeAt(from) || {};
    const mark = marks === null || marks === void 0 ? void 0 : marks.find(m => m.type.name === 'custom-link');
    const href = (_a = mark === null || mark === void 0 ? void 0 : mark.attrs) === null || _a === void 0 ? void 0 : _a.href;
    if (!href) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-col max-w-80 space-y-2 rounded-sm py-2 px-3 text-content-subdued bg-surface shadow-lg border border-line-subdued", children: [_jsxs("div", { className: "flex space-s-2", children: [_jsx(MenuItem, { title: intl.$t({
                                    id: 'Composer.LinkBubbleMenu.UnlinkTitle',
                                    defaultMessage: 'Unlink',
                                }), onClick: () => editor.chain().focus().unsetLink().run(), isActive: true, icon: _jsx(LinkUnlinkIcon, {}, void 0) }, void 0), _jsx(MenuItem, { title: intl.$t({
                                    id: 'Generics.Edit',
                                    defaultMessage: 'Edit',
                                }), onClick: () => {
                                    setLinkFormState({
                                        open: true,
                                        text,
                                        href,
                                    });
                                }, isActive: false, icon: _jsx(EditLineIcon, {}, void 0) }, void 0)] }, void 0), _jsx("div", { className: "text-sm truncate text-content-subdued", title: href, children: href }, void 0)] }, void 0), _jsx(LinkFormDialog, { defaultValues: {
                    text: linkFormState.text,
                    link: linkFormState.href,
                }, onSubmit: data => {
                    const { link, text } = data;
                    if (link) {
                        const { from, to } = editor.view.state.selection;
                        editor
                            .chain()
                            .setTextSelection({ from, to })
                            .insertLink({ href: link, text })
                            .run();
                    }
                    else {
                        editor
                            .chain()
                            .focus()
                            .extendMarkRange('custom-link')
                            .unsetLink()
                            .run();
                    }
                    setLinkFormState({
                        text: '',
                        href: undefined,
                        open: false,
                    });
                }, open: linkFormState.open, onClose: () => {
                    setLinkFormState({
                        text: '',
                        href: undefined,
                        open: false,
                    });
                } }, void 0)] }, void 0));
};
//# sourceMappingURL=LinkBubbleMenu.js.map